import essApi from "../axios/essApi";

class NotificationService {

    async getNotification() {
        return Promise.resolve(essApi.get(`notification`));
    }
    async getNotificationById(reqBody) {
        return Promise.resolve(essApi.get(`notification/${reqBody}`));
    }
    async deleteNotification(id) {
        return Promise.resolve(essApi.delete(`notification/${id}`));
    }
    async deleteAllNotification(reqBody) {
        return Promise.resolve(essApi.post(`notification-All`, reqBody));
    }
    async filterNotificationAccordingToDate(reqBody) {
        return Promise.resolve(essApi.post(`notification-All-date`, reqBody));
    }
}

export default NotificationService;